export class PatientConsultation {
    patientId: number;
    profesionalId: number;
    evaluationId: number;
    observation: string;
    creationDate?: string;
    creatorId?: number;
}



export interface PatientConsultationData {
    creationDate: string;
    evaluationId: number;
    id: number;
    observation: string;
    patientId: number;
    profesionalId: number;
}
